import React from "react";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, Box } from "@mui/material";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import { connect } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import AddIcon from "@mui/icons-material/Add";
import { logout } from "../../actions/middleware_actions";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import mapStateToProps from "../../services/mapStateToProps";
import { useViewport } from "../CustomHooks/useViewport";
import { vendor_software_version } from "../../constants/default_request";

function NavBar({ isAuthUser, toggle }) {
  const width = useViewport();
  const breakpoint = 620;
  const imageUrl = width < breakpoint ? "noaa_logos_mobile.png" : "noaa_logos.png";
  const isMobile = width < breakpoint;
  let theme = createTheme();
  theme = responsiveFontSizes(theme);
  theme.typography.h6 = {
    fontFamily: "Proximanova Reg, sans-serif",
    fontSize: "0.90rem",
    "@media ( min-width:720px)": {
      fontSize: "1.8rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "2rem",
    },
  };
  theme.typography.caption = {
    color: "#0a4595",
    "@media ( min-width:320px)": {
      fontSize: "0.60rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "0.90rem",
    },
  };

  return (
    <div style={{ display: "flex" }}>
      <AppBar style={{ backgroundColor: "white" }}>
        <Toolbar>
          <div className="responsive-drawer drawer-button-container">
            {isAuthUser && !isMobile && (
              <IconButton
                color="inherit"
                aria-label="menu"
                edge="start"
                onClick={toggle}
                className="col-sm-1 button"
                size="large"
              >
                <MenuIcon />
              </IconButton>
            )}
          </div>
          <div className="logo">
            <img
              src={process.env.PUBLIC_URL + `/${imageUrl}`}
              alt="NOAA Logo"
              className="logoHorizontallyCenter"
            />
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    marginTop: isMobile ? "12px" : "16px",
                  }}
                >
                  <Typography variant="h6" className="logo-header">
                    Vessel Trip Reporting
                  </Typography>
                  <Typography variant="caption">
                    Version {vendor_software_version()}
                  </Typography>
                </Box>
              </ThemeProvider>
            </StyledEngineProvider>
          </div>
          <div className="responsive-drawer drawer-icon">
            {isAuthUser && (
              <IconButton size="large">
                <Link className="link" to={`${process.env.PUBLIC_URL}/start-new-trip`}>
                  <AddIcon />
                </Link>
              </IconButton>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

const mapDispatchToProps = () => {
  return {
    logout,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
